/* eslint-disable import/prefer-default-export */
// export const centimetresToMetres = (centimeters: number) => centimeters / 100;

export const metresToCentimetres = (meters: number) => meters * 100;

export const millimetresToCentimetres = (millimeters: number) => millimeters / 10;

export const centimetresToMillimetres = (centimeters: number) => centimeters * 10;
